import Config from '@config';

import { Flags } from './type';

export const defaultFlags: Flags = {
  featureLightDarkMode: Config.VITE_FEATURE_LIGHT_DARK_MODE === 'true',
  featureFlagsSwitcher: Config.VITE_FEATURE_FLAG_SWITCHER === 'true',
  featureReportConstructorDevExtreme:
    Config.VITE_FEATURE_REPORT_CONSTRUCTOR_DEV_EXTREME === 'true',
  featureHouseholdRedirect: Config.VITE_FEATURE_HOUSEHOLD_REDIRECT === 'true',
  featureShowLanguageSwitcher:
    Config.VITE_FEATURE_SHOW_LANGUAGE_SWITCHER === 'true',
};
